import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import DigitizeImg from "../../../images/location_new/fold5/uk-react-native.webp";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link } from "gatsby";

function Digitize(props) {
  return (
    <div className="digitize_sec p-100" style={{ backgroundColor: "#040404" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Achieve Optimal Business Outcomes with a Top-Ranked React Native
              Application Development Company
            </h2>
            <p>
              We are a result-driven React Native app development company in UK,
              dedicated to providing progressive solutions for businesses of all
              sizes. What distinguishes us is not just our dedication to
              excellence but also our understanding of the budget constraints of
              startups and mid-sized businesses.
            </p>
            <p>
              Our team of React Native developers specializes in crafting
              top-notch React Native apps that stand out in the competitive
              market. We’ve developed hundreds of React Native apps with
              advanced functionality ranging from simple to intricate apps. With
              our React Native app development services, you'll experience
              cutting-edge mobile apps & maximum ROI.
            </p>
            <Link
              style={{
                backgroundColor: "#fff",
                color: "#040404",
                border: "1px solid #040404",
              }}
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="digitize_img">
            <LazyLoadImage
              src={DigitizeImg}
              effect="blur"
              alt="react-native-app-development-company-uk"
              className="img-fluid"
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Digitize;
